/**
 * Creates a linear gradient style string from the given offset/hex value
 *
 * @param rgb An array of [offset (0.0 - 1.0), hex]
 * @returns Linear gradient style string
 */
export const createLinearGradientStyleString = (rgb: [number, string][]) => {
  const stops = rgb.map(([offset, hex]) => `${hex} ${offset * 100}%`);
  return `linear-gradient(to right, ${stops.join(', ')})`;
};
